import request from '@/utils/request'

//  会员列表
export const memberList = (pageData, formData) => {
    return request.post(`/member/page/${pageData.page}/${pageData.pageSize}`, formData)
}

//  会员详情
export const detailMember = (id) => {
    return request.get(`/member/${id}`)
}

//  删除用户
export const memberDelete = (memberId) => {
    return request.delete(`/member/${memberId}`)
}

//  会员等级列表
export const listMemberLevel = () => {
    return request.get(`/memberLevel`)
}

// 会员购买订单
export const listMemberOrder = (pageData, formData) => {
    return request.post(`/member/order/page/${pageData.page}/${pageData.pageSize}`, formData)
}

// 批量年度会员免费注册
export const batchFreeRegister = (formData) => {
    return request.post(`/member/batchFreeRegister`, formData)
}